var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._v(" "+_vm._s(_vm.todos)+" "),_c('Todos',{model:{value:(_vm.todos),callback:function ($$v) {_vm.todos=$$v},expression:"todos"}}),_c('Todos',{model:{value:(_vm.todos),callback:function ($$v) {_vm.todos=$$v},expression:"todos"}}),_c('Todos')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }